import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { axiosInterceptor } from '..';
import { QueryKeys } from '../keys';


interface IUseGetCountryResponse {
    countryCode: string;
}

const userCuntryReq = async () => {
    const data = await axiosInterceptor.get<IUseGetCountryResponse>(
        'users/geo/info',
        {
            headers: {
                Authorization: undefined,
            },
        },
    );
    return data.data;
};

const useUserCountry = (
    options?: Omit<Partial<UseQueryOptions<IUseGetCountryResponse>>, 'queryFn'>,
) => {
    return useQuery<IUseGetCountryResponse>({
        queryKey: [QueryKeys.GET_COUNTRY],
        queryFn: async () => {
            return userCuntryReq();
        },
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: Infinity,
        staleTime: Infinity,
        ...options,
    });
};

export default useUserCountry;
